import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IPrivateBreakpointWidgetService = ( createDecorator('privateBreakpointWidgetService'));
export { IPrivateBreakpointWidgetService };
